import React, { useCallback, useEffect, useState } from "react";
import Dropzone from "./Dropzone";
import ColorsFromImage from "./ColorsFromImage";
import {
  palette_from_image_wrapper,
  tool_heading,
  subtitle,
  trust_signals,
  tool_card,
  input_methods,
  input_method,
  input_method_active,
  method_panel,
  paste_panel,
  paste_icon,
  primary_button,
  method_hint,
  url_form,
  url_input,
  error_message,
  result_layout,
  preview_panel,
  image_wrapper,
  change_image_button,
} from "../../../styles/modules/palette_from_image.module.css";

const TEXTS = {
  es: {
    title: "Sacar paleta de colores de una imagen online",
    subtitle:
      "Sube, pega o usa la URL de una imagen para obtener 6 colores dominantes y sus códigos HEX.",
    private: "Procesamiento privado",
    noAccount: "Sin registro",
    free: "Gratis",
    uploadTab: "Subir archivo",
    pasteTab: "Pegar imagen",
    urlTab: "Usar URL",
    pasteTitle: "Pega una imagen desde el portapapeles",
    pasteButton: "Pegar imagen",
    pasteHint: "También puedes usar Ctrl+V o ⌘+V en cualquier momento.",
    pasteUnavailable:
      "El navegador no permitió leer el portapapeles. Usa Ctrl+V o selecciona un archivo.",
    noImageInClipboard: "No encontramos una imagen en el portapapeles.",
    urlLabel: "URL pública de la imagen",
    urlPlaceholder: "https://ejemplo.com/imagen.jpg",
    urlButton: "Extraer colores",
    urlHint:
      "Algunas páginas impiden usar sus imágenes. Si ocurre, descárgala y súbela como archivo.",
    invalidUrl: "Introduce una URL válida que empiece por http:// o https://.",
    urlError:
      "No pudimos abrir esa imagen. Comprueba la URL o utiliza un archivo guardado en tu dispositivo.",
    invalidFile: "Selecciona una imagen JPG, PNG, WEBP o GIF.",
    readingError: "No pudimos leer la imagen seleccionada.",
    loadingUrl: "Abriendo imagen…",
    previewAlt: "Imagen utilizada para extraer la paleta de colores",
    changeImage: "Cambiar imagen",
  },
  en: {
    title: "Extract colors from an image",
    subtitle:
      "Upload, paste, or use an image URL to get 6 dominant colors and their HEX codes.",
    private: "Private processing",
    noAccount: "No sign-up",
    free: "Free",
    uploadTab: "Upload file",
    pasteTab: "Paste image",
    urlTab: "Use URL",
    pasteTitle: "Paste an image from your clipboard",
    pasteButton: "Paste image",
    pasteHint: "You can also press Ctrl+V or ⌘+V at any time.",
    pasteUnavailable:
      "The browser could not read your clipboard. Press Ctrl+V or select a file instead.",
    noImageInClipboard: "There is no image in your clipboard.",
    urlLabel: "Public image URL",
    urlPlaceholder: "https://example.com/image.jpg",
    urlButton: "Extract colors",
    urlHint:
      "Some websites block access to their images. If that happens, download and upload the file.",
    invalidUrl: "Enter a valid URL beginning with http:// or https://.",
    urlError:
      "We could not open that image. Check the URL or upload a file saved on your device.",
    invalidFile: "Select a JPG, PNG, WEBP, or GIF image.",
    readingError: "We could not read the selected image.",
    loadingUrl: "Opening image…",
    previewAlt: "Image used to extract the color palette",
    changeImage: "Change image",
  },
  pt: {
    title: "Extrair cores de uma imagem",
    subtitle:
      "Carregue, cole ou use a URL de uma imagem para obter 6 cores dominantes e seus códigos HEX.",
    private: "Processamento privado",
    noAccount: "Sem cadastro",
    free: "Grátis",
    uploadTab: "Carregar arquivo",
    pasteTab: "Colar imagem",
    urlTab: "Usar URL",
    pasteTitle: "Cole uma imagem da área de transferência",
    pasteButton: "Colar imagem",
    pasteHint: "Você também pode usar Ctrl+V ou ⌘+V a qualquer momento.",
    pasteUnavailable:
      "O navegador não permitiu ler a área de transferência. Use Ctrl+V ou selecione um arquivo.",
    noImageInClipboard: "Não encontramos uma imagem na área de transferência.",
    urlLabel: "URL pública da imagem",
    urlPlaceholder: "https://exemplo.com/imagem.jpg",
    urlButton: "Extrair cores",
    urlHint:
      "Alguns sites bloqueiam o acesso às suas imagens. Nesse caso, baixe e carregue o arquivo.",
    invalidUrl: "Insira uma URL válida começando com http:// ou https://.",
    urlError:
      "Não foi possível abrir essa imagem. Verifique a URL ou carregue um arquivo do dispositivo.",
    invalidFile: "Selecione uma imagem JPG, PNG, WEBP ou GIF.",
    readingError: "Não foi possível ler a imagem selecionada.",
    loadingUrl: "Abrindo imagem…",
    previewAlt: "Imagem usada para extrair a paleta de cores",
    changeImage: "Trocar imagem",
  },
  fr: {
    title: "Extraire les couleurs d'une image",
    subtitle:
      "Importez, collez ou utilisez l’URL d’une image pour obtenir 6 couleurs dominantes et leurs codes HEX.",
    private: "Traitement privé",
    noAccount: "Sans inscription",
    free: "Gratuit",
    uploadTab: "Importer",
    pasteTab: "Coller l'image",
    urlTab: "Utiliser une URL",
    pasteTitle: "Collez une image depuis le presse-papiers",
    pasteButton: "Coller une image",
    pasteHint: "Vous pouvez aussi utiliser Ctrl+V ou ⌘+V à tout moment.",
    pasteUnavailable:
      "Le navigateur n’a pas pu lire le presse-papiers. Utilisez Ctrl+V ou sélectionnez un fichier.",
    noImageInClipboard: "Aucune image n’a été trouvée dans le presse-papiers.",
    urlLabel: "URL publique de l'image",
    urlPlaceholder: "https://exemple.com/image.jpg",
    urlButton: "Extraire les couleurs",
    urlHint:
      "Certains sites bloquent l’accès à leurs images. Dans ce cas, téléchargez puis importez le fichier.",
    invalidUrl: "Saisissez une URL valide commençant par http:// ou https://.",
    urlError:
      "Impossible d’ouvrir cette image. Vérifiez l’URL ou importez un fichier depuis votre appareil.",
    invalidFile: "Sélectionnez une image JPG, PNG, WEBP ou GIF.",
    readingError: "Impossible de lire l’image sélectionnée.",
    loadingUrl: "Ouverture de l’image…",
    previewAlt: "Image utilisée pour extraire la palette de couleurs",
    changeImage: "Changer d’image",
  },
  de: {
    title: "Farben aus einem Bild extrahieren",
    subtitle:
      "Lade ein Bild hoch, füge es ein oder nutze eine URL, um 6 dominante Farben und ihre HEX-Codes zu erhalten.",
    private: "Private Verarbeitung",
    noAccount: "Ohne Anmeldung",
    free: "Kostenlos",
    uploadTab: "Datei hochladen",
    pasteTab: "Bild einfügen",
    urlTab: "URL verwenden",
    pasteTitle: "Bild aus der Zwischenablage einfügen",
    pasteButton: "Bild einfügen",
    pasteHint: "Du kannst jederzeit auch Strg+V oder ⌘+V verwenden.",
    pasteUnavailable:
      "Der Browser konnte die Zwischenablage nicht lesen. Verwende Strg+V oder wähle eine Datei.",
    noImageInClipboard: "In der Zwischenablage wurde kein Bild gefunden.",
    urlLabel: "Öffentliche Bild-URL",
    urlPlaceholder: "https://beispiel.de/bild.jpg",
    urlButton: "Farben extrahieren",
    urlHint:
      "Einige Websites blockieren den Zugriff auf ihre Bilder. Lade die Datei dann herunter und hier hoch.",
    invalidUrl:
      "Gib eine gültige URL ein, die mit http:// oder https:// beginnt.",
    urlError:
      "Dieses Bild konnte nicht geöffnet werden. Prüfe die URL oder lade eine gespeicherte Datei hoch.",
    invalidFile: "Wähle ein JPG-, PNG-, WEBP- oder GIF-Bild aus.",
    readingError: "Das ausgewählte Bild konnte nicht gelesen werden.",
    loadingUrl: "Bild wird geöffnet…",
    previewAlt: "Bild, aus dem die Farbpalette extrahiert wurde",
    changeImage: "Bild wechseln",
  },
};

const IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp", "image/gif"];

const readFileAsDataUrl = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = event => resolve(event.target.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

function PaletteFromImage({ locale }) {
  const texts = TEXTS[locale] || TEXTS.es;
  const [images, setImages] = useState([]);
  const [activeMethod, setActiveMethod] = useState("upload");
  const [urlValue, setUrlValue] = useState("");
  const [isImporting, setIsImporting] = useState(false);
  const [error, setError] = useState("");

  const setImageFromFile = useCallback(
    async file => {
      if (!file || !IMAGE_TYPES.includes(file.type)) {
        setError(texts.invalidFile);
        return;
      }

      setError("");

      try {
        const src = await readFileAsDataUrl(file);
        setImages([
          {
            id: `${Date.now()}-${file.name}`,
            src,
            name: file.name || "image",
          },
        ]);
      } catch (fileError) {
        setError(texts.readingError);
      }
    },
    [texts.invalidFile, texts.readingError]
  );

  const onDrop = useCallback(
    (acceptedFiles, fileRejections = []) => {
      if (fileRejections.length || !acceptedFiles.length) {
        setError(texts.invalidFile);
        return;
      }

      setImageFromFile(acceptedFiles[0]);
    },
    [setImageFromFile, texts.invalidFile]
  );

  const handleClipboardItems = useCallback(
    async items => {
      const imageItem = Array.from(items).find(item => {
        const type =
          item.type || item.types?.find(value => value.startsWith("image/"));
        return type?.startsWith("image/");
      });

      if (!imageItem) {
        setError(texts.noImageInClipboard);
        return;
      }

      const imageType =
        imageItem.type ||
        imageItem.types.find(type => type.startsWith("image/"));
      const file = imageItem.getAsFile
        ? imageItem.getAsFile()
        : await imageItem.getType(imageType);

      if (!file) {
        setError(texts.noImageInClipboard);
        return;
      }

      const extension =
        imageType.split("/")[1]?.replace("jpeg", "jpg") || "png";
      const namedFile = new File([file], `clipboard-image.${extension}`, {
        type: imageType,
      });
      await setImageFromFile(namedFile);
    },
    [setImageFromFile, texts.noImageInClipboard]
  );

  useEffect(() => {
    const handlePaste = event => {
      const items = event.clipboardData?.items;
      const hasImage = Array.from(items || []).some(item =>
        item.type.startsWith("image/")
      );

      if (hasImage) {
        event.preventDefault();
        handleClipboardItems(items);
      }
    };

    window.addEventListener("paste", handlePaste);
    return () => window.removeEventListener("paste", handlePaste);
  }, [handleClipboardItems]);

  const pasteFromClipboard = useCallback(async () => {
    if (!navigator.clipboard?.read) {
      setError(texts.pasteUnavailable);
      return;
    }

    setError("");

    try {
      const items = await navigator.clipboard.read();
      await handleClipboardItems(items);
    } catch (clipboardError) {
      setError(texts.pasteUnavailable);
    }
  }, [handleClipboardItems, texts.pasteUnavailable]);

  const importFromUrl = useCallback(
    async event => {
      event.preventDefault();
      setError("");

      let imageUrl;
      try {
        imageUrl = new URL(urlValue);
        if (!["http:", "https:"].includes(imageUrl.protocol)) {
          throw new Error("Invalid protocol");
        }
      } catch (urlError) {
        setError(texts.invalidUrl);
        return;
      }

      setIsImporting(true);

      try {
        const response = await fetch(imageUrl.href, { mode: "cors" });
        if (!response.ok) {
          throw new Error("Image request failed");
        }

        const blob = await response.blob();
        if (blob.type && !IMAGE_TYPES.includes(blob.type)) {
          throw new Error("Unsupported image type");
        }

        const pathnameName = imageUrl.pathname.split("/").pop() || "url-image";
        const file = new File([blob], pathnameName, {
          type: blob.type || "image/jpeg",
        });
        await setImageFromFile(file);
      } catch (requestError) {
        setError(texts.urlError);
      } finally {
        setIsImporting(false);
      }
    },
    [setImageFromFile, texts.invalidUrl, texts.urlError, urlValue]
  );

  const clearImage = useCallback(() => {
    setImages([]);
    setError("");
  }, []);

  const changeMethod = method => {
    setActiveMethod(method);
    setError("");
  };

  const methodLabels = {
    upload: texts.uploadTab,
    paste: texts.pasteTab,
    url: texts.urlTab,
  };

  return (
    <section
      className={palette_from_image_wrapper}
      aria-labelledby="image-color-tool-title"
    >
      <header className={tool_heading}>
        <h1 id="image-color-tool-title">{texts.title}</h1>
        <p className={subtitle}>{texts.subtitle}</p>
        <ul className={trust_signals} aria-label={texts.private}>
          <li>{texts.private}</li>
          <li>{texts.noAccount}</li>
          <li>{texts.free}</li>
        </ul>
      </header>

      {images.length === 0 ? (
        <div className={tool_card}>
          <div
            className={input_methods}
            role="tablist"
            aria-label={texts.title}
          >
            {Object.keys(methodLabels).map(method => (
              <button
                key={method}
                type="button"
                role="tab"
                aria-selected={activeMethod === method}
                aria-controls={`method-panel-${method}`}
                className={`${input_method} ${
                  activeMethod === method ? input_method_active : ""
                }`}
                onClick={() => changeMethod(method)}
              >
                {methodLabels[method]}
              </button>
            ))}
          </div>

          <div
            id={`method-panel-${activeMethod}`}
            className={method_panel}
            role="tabpanel"
          >
            {activeMethod === "upload" ? (
              <Dropzone onDrop={onDrop} locale={locale} />
            ) : null}

            {activeMethod === "paste" ? (
              <div className={paste_panel}>
                <svg
                  className={paste_icon}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  aria-hidden="true"
                >
                  <rect x="7" y="4" width="10" height="4" rx="1" />
                  <path d="M9 6H6a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-3" />
                  <path d="m9 15 2 2 4-5" />
                </svg>
                <h2>{texts.pasteTitle}</h2>
                <button
                  type="button"
                  className={primary_button}
                  onClick={pasteFromClipboard}
                >
                  {texts.pasteButton}
                </button>
                <p className={method_hint}>{texts.pasteHint}</p>
              </div>
            ) : null}

            {activeMethod === "url" ? (
              <form className={url_form} onSubmit={importFromUrl}>
                <label htmlFor="image-url">{texts.urlLabel}</label>
                <div>
                  <input
                    id="image-url"
                    className={url_input}
                    type="url"
                    inputMode="url"
                    placeholder={texts.urlPlaceholder}
                    value={urlValue}
                    onChange={event => setUrlValue(event.target.value)}
                    required
                  />
                  <button
                    type="submit"
                    className={primary_button}
                    disabled={isImporting}
                  >
                    {isImporting ? texts.loadingUrl : texts.urlButton}
                  </button>
                </div>
                <p className={method_hint}>{texts.urlHint}</p>
              </form>
            ) : null}
          </div>

          {error ? (
            <p className={error_message} role="alert">
              {error}
            </p>
          ) : null}
        </div>
      ) : (
        <div className={result_layout}>
          <div className={preview_panel}>
            <div className={image_wrapper}>
              <img src={images[0].src} alt={texts.previewAlt} />
            </div>
            <button
              type="button"
              className={change_image_button}
              onClick={clearImage}
            >
              {texts.changeImage}
            </button>
          </div>

          <ColorsFromImage locale={locale} images={images} />
        </div>
      )}
    </section>
  );
}

export default PaletteFromImage;
